
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/committee",
      function () {
        return require("private-next-pages/committee/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/committee"])
      });
    }
  